import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { DollarSign, CalendarClock, TrendingUp, GraduationCap, Briefcase, Check, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const BENEFITS = [
  { icon: DollarSign, t: "Competitive Pay", d: "Get matched to opportunities that value your experience." },
  { icon: CalendarClock, t: "Flexible Schedules", d: "Choose shifts and clients that fit your life." },
  { icon: GraduationCap, t: "Training & Certification", d: "Grow your skills through the T5 Academy." },
  { icon: TrendingUp, t: "Career Growth", d: "Advance from caregiver to lead, trainer or agency partner." },
];
const IMG = "https://images.unsplash.com/photo-1736289189363-4af449f7e6fc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000";

export default function Caregivers() {
  const navigate = useNavigate();
  return (
    <div>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <p className="text-xs uppercase tracking-[0.16em] text-teal-600 font-semibold mb-3">For Caregivers</p>
          <h1 className="font-display text-4xl lg:text-5xl font-bold text-blue-950 leading-tight">Build a caregiving career you're proud of.</h1>
          <p className="mt-4 text-slate-600 text-lg leading-relaxed">Create your profile, complete training, and discover opportunities with families and agencies across the T5 network.</p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Button onClick={() => navigate("/register")} data-testid="cg-join" className="h-12 px-7 bg-blue-950 hover:bg-blue-900 text-white">Join T5</Button>
            <Button onClick={() => navigate("/register")} data-testid="cg-profile" variant="outline" className="h-12 px-7 border-blue-900/25 text-blue-900">Create Your Profile</Button>
          </div>
        </div>
        <img src={IMG} alt="T5 caregiver" className="rounded-3xl shadow-2xl w-full object-cover aspect-[4/3.6]" />
      </section>

      <section className="bg-white border-y border-blue-900/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {BENEFITS.map((b, i) => (
            <motion.div key={b.t} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.06 }}
              className="rounded-2xl p-6 bg-[#FAF9F6] border border-blue-900/5">
              <span className="grid place-items-center w-12 h-12 rounded-xl bg-teal-50 text-teal-700 mb-4"><b.icon className="w-6 h-6" /></span>
              <h3 className="font-display font-semibold text-blue-950">{b.t}</h3>
              <p className="mt-1.5 text-sm text-slate-500 leading-relaxed">{b.d}</p>
            </motion.div>
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="rounded-3xl bg-blue-950 text-white p-10 lg:p-14 flex flex-col lg:flex-row items-center justify-between gap-6">
          <div><Briefcase className="w-9 h-9 text-teal-400 mb-3" /><h2 className="font-display text-3xl font-bold">Grow with the T5 Academy</h2><p className="mt-2 text-blue-100/80 max-w-xl">Foundations, dementia care, communication, safety and leadership — self-paced courses with certificates.</p></div>
          <Button onClick={() => navigate("/store")} className="h-12 px-7 bg-teal-500 hover:bg-teal-600 text-white gap-2 shrink-0">Explore Courses <ArrowRight className="w-4 h-4" /></Button>
        </div>
      </section>
    </div>
  );
}
